import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Validation } from "../../../domain/validation/Validation";
import { Card, Stack } from "@mui/material";
import {
  STRINGS_EMAIL,
  STRINGS_EMAIL_NOT_VALID,
  STRINGS_EMAIL_REQUIRED,
  STRINGS_LOGIN,
  STRINGS_PASSWORD,
  STRINGS_PASSWORD_REQUIRED,
} from "../../../data/strings/Strings";
import {
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import AutoHeight from "../../component/AutoHeightView";
import { EmailRounded, LockRounded } from "@mui/icons-material";
import { CustomTextView } from "../../component/CustomTextView";
import { CustomTextField } from "../../component/CustomTextField";
import { CustomButtonView } from "../../component/CustomButtonView";

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
}

function LoginForm({ onSubmit }: LoginFormProps) {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (email: string) => {
    setEmail(email);
  };

  const handlePasswordChange = (password: string) => {
    setPassword(password);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errors = validateInputs();
    setErrors(errors);

    if (Object.keys(errors).length === 0) onSubmit(email, password);
  };

  const validateInputs = () => {
    const errors: { [key: string]: string } = {};
    const emailValid = Validation.validateEmail(email);
    if (emailValid !== true) {
      errors.email = STRINGS_EMAIL_NOT_VALID;
    }
    if (email.length === 0) {
      errors.email = STRINGS_EMAIL_REQUIRED;
    }
    if (password.length === 0) {
      errors.password = STRINGS_PASSWORD_REQUIRED;
    }
    return errors;
  };

  const { width } = useWindowDimensions();

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      noValidate
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Card
        elevation={0}
        sx={{
          flex: 1,
          py: "8%",
          px: "6%",
          margin: "8%",
          borderRadius: 12,
          minWidth: "25vw",
          width: "100%",
          backgroundColor: COLOR_WHITE,
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Stack spacing={8} flex={1}>
          <CustomTextView
            text={STRINGS_LOGIN}
            variant="h3"
            fontWeight="700"
            textColor={COLOR_MAIN}
          />

          <Stack spacing={2}>
            <AutoHeight>
              <CustomTextField
                type="email"
                placeholder={STRINGS_EMAIL}
                isFullWidth
                onTextChange={handleEmailChange}
                error={!!errors.email}
                helperText={errors.email}
                startIcon={<EmailRounded sx={{ color: COLOR_MAIN }} />}
                onHoverBorderColor={COLOR_LIGHT_GRAY}
                onFocusBorderColor={COLOR_LIGHT_GRAY}
                backgroundColor={"transparent"}
              />
            </AutoHeight>
            <AutoHeight>
              <CustomTextField
                type="password"
                placeholder={STRINGS_PASSWORD}
                isFullWidth
                onTextChange={handlePasswordChange}
                error={!!errors.password}
                helperText={errors.password}
                startIcon={<LockRounded sx={{ color: COLOR_MAIN }} />}
                onHoverBorderColor={COLOR_LIGHT_GRAY}
                onFocusBorderColor={COLOR_LIGHT_GRAY}
                backgroundColor={"transparent"}
              />
            </AutoHeight>

            <CustomButtonView
              text={STRINGS_LOGIN}
              fontSize="h6"
              type="submit"
              props={{ py: 0.5 }}
            />
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
}

export default LoginForm;
